import {
  demoStudios,
  generateDemoArticles,
  generateDemoPortfolios,
} from "./demoData";

export const upgradeDB = (db) => {
  if (!db.objectStoreNames.contains("studios")) {
    db.createObjectStore("studios", { keyPath: "id" });
  }
  if (!db.objectStoreNames.contains("articles")) {
    db.createObjectStore("articles", { keyPath: "id" });
  }
  if (!db.objectStoreNames.contains("portfolios")) {
    db.createObjectStore("portfolios", { keyPath: "id" });
  }
};

export const seedStudios = async (db) => {
  const tx = db.transaction("studios", "readwrite");
  const store = tx.objectStore("studios");

  for (const studio of demoStudios) {
    await store.put(studio);
  }

  await tx.done;
};

export const seedArticles = async (db) => {
  const tx = db.transaction("articles", "readwrite");
  const store = tx.objectStore("articles");

  for (const studio of demoStudios) {
    const articles = generateDemoArticles(studio.id);
    for (const article of articles) {
      await store.put(article);
    }
  }

  await tx.done;
};

export const seedPortfolios = async (db) => {
  const tx = db.transaction("portfolios", "readwrite");
  const store = tx.objectStore("portfolios");

  for (const studio of demoStudios) {
    const portfolios = generateDemoPortfolios(studio.id);
    for (const portfolio of portfolios) {
      await store.put(portfolio);
    }
  }

  await tx.done;
};
